





























































































































































import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import {
  CheckedInCustomersOnAccUnitType,
  eVisitorArrivalOrganizationTypesEnum,
  ReservationCheckInCustomerData,
  SetCheckedInCustomers,
} from "./CheckinTypes";
import {
  EVisitorFacilityService,
  eVisitorFacilityServiceFactory,
} from "./eVisitorFacilityService";
import {
  OcrData,
  assignToReservationCheckInCustomerData,
  getIdentificationDocumentType,
} from "./OcrData";
import CheckInGuestCard from "./CheckInGuestCard.vue";
import _ from "lodash";
import { Getter } from "vuex-class";
import { HubConnection, HubConnectionBuilder, LogLevel } from "@aspnet/signalr";
import { Country } from "@/shared/models/country";
import { DateTime } from "luxon";
import { ReservationModel } from "../types";
import { ReservationStatus } from "@/shared/models/reservationStatus";
import { Ota } from "@/shared/models/ota";
import ScannerDebug, { RawScanDescriptor } from "./ScannerDebug.vue";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { ArrivalReason } from "@/shared/models/arrivalReason";
import TableCellUnitTypeDisplay from "@/components/misc/TableCellUnitTypeDisplay.vue";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
} from "@/shared/models/enums.type";
import { IdentificationDocumentTypesEnum } from "@/shared/enums/identificationDocumentTypes.type";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";

@Component({
  components: { CheckInGuestCard, ScannerDebug, TableCellUnitTypeDisplay },
})
export default class CheckInModalForm extends Vue {
  @PropSync("open", { default: false }) internalOpen?: boolean;
  @PropSync("loading", { default: false }) isLoading?: boolean;

  @Prop({ default: null }) scrollId!: string | null;
  @Prop({ default: null }) singleUnit!: number | null;

  @Getter("appParams/statusToCheckedInState") statusToCheckedInState?: boolean;
  @Getter("appParams/checkInOnEVisitorState") checkInOnEVisitorState?: boolean;

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }
  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  get showEvisitor() {
    return this.eVisitorIntegration?.id !== EVisitorIntegrationEnum.None;
  }
  
  @Watch("internalOpen", { immediate: true })
  internalOpenChanged(fresh: boolean, old: boolean) {
    this.retryAttempt = 0;
    if (fresh && (!this.connection || !this.connected)) {
      this.connected = false;
      this.start();
    }

    if (fresh && fresh !== old) {
      this.tab = 0;
      this.updateResStatus = this.statusToCheckedInState ?? false;
      this.eVisitorCheck = this.checkInOnEVisitorState ?? false;
      this.eVisitorFacilityService = null;
    }
  }

  @Prop() reservation?: ReservationModel;

  internalValue: CheckedInCustomersOnAccUnitType[] = [];
  @Prop() value?: CheckedInCustomersOnAccUnitType[];
  @Watch("value", { immediate: true })
  valueChanged(fresh: CheckedInCustomersOnAccUnitType[]) {
    this.internalValue = fresh ?? [];
    if (!this.internalValue.some((x) => !x.isDayStay)) {
      this.eVisitorCheck = false;
    }

    //open acc unit type tab that user clicked on the grid
    //do this only for group reservations
    if (this.scrollId && this.internalValue.length > 1) {
      this.tab = this.internalValue.findIndex(
        (x) => x.reservationAccUnitTypeId == parseInt(this.scrollId ?? "")
      );
    }

    if (this.singleUnit !== null) {
      this.internalValue = this.internalValue.filter(
        (x) => x.accomodationUnitId == this.singleUnit
      );
    }

    for (const aut of this.internalValue) {
      for (const emptyGuest of aut.guests) {
        this.prefilMiscCustomerData(aut, emptyGuest);
      }
    }

    const guestsByFacility = _.groupBy(
      this.internalValue.flatMap((x) => x.guests),
      (x) => x.eVisitorFacilityId
    );
    const initialCheckedInGuestCountOnFacility = _.map(
      guestsByFacility,
      (v, k) => ({
        eVisitorFacilityId: +k,
        count: v.filter((x) => !x.eVisitorIsCheckedOut).length,
      })
    );

    if (!this.eVisitorFacilityService) {
      this.eVisitorFacilityService = eVisitorFacilityServiceFactory(
        this,
        initialCheckedInGuestCountOnFacility
      );
    }

    const thisPropId = this.reservation?.accomodationUnitTypes?.length
      ? this.reservation?.accomodationUnitTypes[0].propertyId ?? 0
      : 0;

    const facilityProperyIds = this.internalValue
      .flatMap((x) => x.guests)
      .filter((x) => x.eVisitorFacilityPropertyId)
      .map((x) => x.eVisitorFacilityPropertyId as number);

    const distinctFacilityProperyIds = thisPropId
      ? _.uniq([thisPropId, ...facilityProperyIds])
      : _.uniq(facilityProperyIds);

    for (const propId of distinctFacilityProperyIds) {
      const promise = this.eVisitorFacilityService?.loadGroup(propId);
      promise.then((x) => {
        if (x && x.length === 1) {
          for (const aut of this.internalValue) {
            for (const emptyGuest of aut.guests.filter(
              (x) =>
                !x.eVisitorFacilityId && x.eVisitorFacilityPropertyId === propId
            )) {
              emptyGuest.eVisitorFacilityId = x[0].id;
            }
          }
        }
      });
    }
  }

  tab = 0;

  updateResStatus = false;

  eVisitorCheck = false;

  get reservationId() {
    return this.reservation?.id;
  }

  get firstGuestOrganizationTypeId() {
    if (
      this.internalValue &&
      this.internalValue.length > 0 &&
      this.internalValue[0].guests.length > 0
    ) {
      return (
        this.internalValue[0].guests[0].eVisitorArrivalOrganizationTypeId ??
        eVisitorArrivalOrganizationTypesEnum.Osobno
      );
    }
    return eVisitorArrivalOrganizationTypesEnum.Osobno;
  }

  get updateStatusLabel() {
    if (this.singleUnit === null) {
      return this.$t("Update reservation status to check-in");
    }

    return this.$t("Update unit status to check-in");
  }

  get allGuestsFlat() {
    return this.internalValue?.flatMap((x) => x.guests);
  }

  get reservationHolderName() {
    return this.reservation?.customer?.name ?? "";
  }

  get eVisitorSyncAmount() {
    const guestsForSync = this.internalValue
      ?.flatMap((x) => x.guests)
      .filter((x) => !x.eVisitorIsCheckedOut && !x.eVisitorIsCheckedIn)
      .filter((x) => x.isDirty || !x.isEmpty);

    const total = guestsForSync.length;
    const progress = guestsForSync.filter(
      (x) => x.eVisitorCheckinResult !== null
    ).length;

    if (total === 0) {
      return 0;
    } else {
      return (100 * progress) / total;
    }
  }

  @Getter("codebooks/otas") otas?: Ota[];
  get reservationOtaDisplay() {
    const tr = this.otas?.find((x) => x.id === this.reservation?.otaid)?.name;
    return tr ?? "";
  }

  @Getter("codebooks/reservationStatuses")
  reservationStatuses?: ReservationStatus[];
  get reservationStatusDisplay() {
    const tr = this.reservationStatuses?.find(
      (x) => x.id === this.reservation?.statusId
    )?.textResourceKey;
    return tr ? this.$t(tr) : "";
  }

  // i just want to load this for children,
  // don't care about this data in any other regard
  @Getter("codebooks/identificationDocumentTypes")
  _identificationDocumentTypes?: IdentificationDocumentType[];
  @Getter("codebooks/countries") _countries?: Country[];
  @Getter("codebooks/cityTaxCategories") _cityTaxCategories?: any[];
  @Getter("codebooks/arrivalReasons") _arrivalReasons?: ArrivalReason[];
  @Getter("codebooks/arrivalOrganizationTypes")
  _arrivalOrganizationTypes?: any[];

  eVisitorFacilityService: EVisitorFacilityService | null = null;

  mounted() {
    if (
      !this._identificationDocumentTypes ||
      this._identificationDocumentTypes.length == 0
    ) {
      this.$store.dispatch("codebooks/refreshIdentificationDocumentTypes");
    }
    if (!this._countries || this._countries.length == 0) {
      this.$store.dispatch("codebooks/refreshCountries");
    }
    if (!this._countries || this._countries.length == 0) {
      this.$store.dispatch("codebooks/refreshCountries");
    }
    if (!this._cityTaxCategories || this._cityTaxCategories.length == 0) {
      this.$store.dispatch("codebooks/refreshCityTaxCategories");
    }
    if (!this._arrivalReasons || this._arrivalReasons.length == 0) {
      this.$store.dispatch("codebooks/refreshArrivalReasons");
    }
    if (
      !this._arrivalOrganizationTypes ||
      this._arrivalOrganizationTypes.length == 0
    ) {
      this.$store.dispatch("codebooks/refresharrivalOrganizationTypes");
    }
  }

  destroyed() {
    this.stopping = true;
    this.connection?.stop().then(() => (this.connected = false));
  }

  closeModal() {
    this.internalOpen = false;
  }

  findScrollableRef() {
    // prettier-ignore
    const scrollableRef = (this.$refs["tabs"] as Vue)
      ?.$el
      ?.querySelector(".v-window");

    return scrollableRef;
  }

  addGuest(aut: CheckedInCustomersOnAccUnitType) {
    const guest = new ReservationCheckInCustomerData();
    this.prefilMiscCustomerData(aut, guest);

    const fakeIds = aut.guests.map((x) => x.id).filter((x) => x < 0);
    const minFakeId = fakeIds.reduce((x, acc) => (x < acc ? x : acc), 0);
    guest.id = minFakeId - 1;

    aut.guests.push(guest);

    const scrollableRef = this.findScrollableRef();
    if (scrollableRef) {
      this.$nextTick(() => {
        scrollableRef.scrollTop =
          scrollableRef.scrollHeight - scrollableRef.clientHeight;
      });
    }
  }
  removeGuest(
    aut: CheckedInCustomersOnAccUnitType,
    guest: ReservationCheckInCustomerData
  ) {
    aut.guests = aut.guests.filter((x) => x !== guest);
  }

  holderSelected(selected: ReservationCheckInCustomerData) {
    const isReservationHolderCheckedIn =
      this.internalValue
        .flatMap((x) => x.guests)
        .find((x) => x.isReservationHolder) !== undefined;

    for (const g of this.internalValue
      .flatMap((x) => x.guests)
      .filter((x) => x.isReservationHolder || x === selected)) {
      if (g !== selected) {
        g.isReservationHolder = false;
      } else {
        if (
          g.isReservationHolder === false &&
          !this.reservation?.customer.isLegalEntity &&
          g.guestId === 0
        ) {
          g.guestId = isReservationHolderCheckedIn
            ? 0
            : this.reservation?.customer.id ?? 0;
        }
        g.isReservationHolder = !g.isReservationHolder;
      }
    }
  }

  @Ref("form") formRef?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  async submit() {
    const valid = this.formRef?.validate();

    if (!valid) {
      if (this.eVisitorCheck) {
        const guestsWithMissingFacility = this.internalValue
          .flatMap((e) => e.guests)
          .filter((e) => !e.eVisitorFacilityId);
        guestsWithMissingFacility.forEach((e) => {
          const cards = this.$refs.guestCards as CheckInGuestCard[];
          const card = cards?.find((x) => x.guest?.id === e.id);
          if (card) {
            // these seem like they should be boolean flags for open/closed, but are actually indexes of opened expansion panels
            card.eVisitorOpen = 0;
            this.$nextTick(() => {
              card.facilityOpen = 0;
            });
          }
        });
        if (guestsWithMissingFacility.length > 0) {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("EVisitor.DVI.MissingFacilityId", {
              eVisitorServiceName: this.eVisitorIntegrationName,
            }),
            timeout: 5000,
          });
        }
      }

      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    const copy = _.cloneDeep(this.internalValue) ?? [];

    const nullEmpty = function (val: string | null) {
      const trimmed = val?.trim() ?? "";
      return trimmed === "" ? null : trimmed;
    };

    for (const aut of copy) {
      aut.guests = aut.guests.filter((x) => !x.isEmpty || x.id > 0);

      for (const g of aut.guests) {
        g.checkInDate = nullEmpty(g.checkInDate);
        g.checkOutDate = nullEmpty(g.checkOutDate);
        g.dateOfBirth = nullEmpty(g.dateOfBirth);
        g.eVisitorCheckInDate = nullEmpty(g.eVisitorCheckInDate);
        g.eVisitorCheckoutDate = nullEmpty(g.eVisitorCheckoutDate);
        g.eVisitorExpectedCheckoutDate = nullEmpty(
          g.eVisitorExpectedCheckoutDate
        );
        g.eVisitorCheckInTime = nullEmpty(
          g.eVisitorCheckInTime?.substr(0, 5) ?? null
        );
        g.eVisitorCheckoutTime = nullEmpty(
          g.eVisitorCheckoutTime?.substr(0, 5) ?? null
        );
        g.eVisitorExpectedCheckoutTime = nullEmpty(
          g.eVisitorExpectedCheckoutTime?.substr(0, 5) ?? null
        );
        g.eVisitorPaymentCategoryId =
          g.eVisitorPaymentCategoryId ??
          g.getEffectiveEVisitorPaymentCategoryId(this.eVisitorIntegrationId);
        g.eVisitorArrivalOrganizationTypeId =
          g.eVisitorArrivalOrganizationTypeId ??
          this.firstGuestOrganizationTypeId ??
          eVisitorArrivalOrganizationTypesEnum.Osobno;
        g.id = g.id >= 0 ? g.id : 0;

        const group = this.eVisitorFacilityService?.findGroup(
          g.eVisitorFacilityPropertyId ?? 0
        );
        if (!group?.facilities.some((x) => x.id === g.eVisitorFacilityId)) {
          g.eVisitorFacilityId = null;
        }
      }
    }

    const sendData = new SetCheckedInCustomers(
      this.reservationId ?? 0,
      this.updateResStatus
    );
    sendData.payload = copy;

    this.$emit("saved", {
      sendData,
      checkInToEVisitor: this.eVisitorCheck,
      singleUnitId: this.singleUnit,
    });
  }

  retryAttempt = 0;
  connection: HubConnection | null = null;
  connected = false;
  startedPromise: Promise<any> | null = null;
  stopping = false;
  shake = false;
  scanFail = false;

  beginShake() {
    this.shake = true;
    setTimeout(() => {
      this.shake = false;
    }, 1000);
  }

  beginScanfail() {
    this.scanFail = true;
    setTimeout(() => {
      this.scanFail = false;
    }, 1000);
  }

  start() {
    const connection = new HubConnectionBuilder()
      .withUrl(`http://localhost:57019/scanner`)
      .configureLogging(LogLevel.Error)
      .build();

    connection.onclose(() => {
      // simple retry logic...
      if (!this.stopping) this.start();
    });

    let otherCounter = -1;
    connection.on("other", (message: string) => {
      if (!this.internalOpen) {
        return;
      }

      const newEvent = {
        id: 0,
        timestamp: DateTime.local().toJSON(),
        name: message,
      };

      const last = this.debugData.slice(-1)[0];
      if (last && last.raw == "") {
        newEvent.id = (last.events.slice(-1)[0]?.id ?? 0) + 1;
        last.events.push(newEvent);
      } else {
        const descriptor = {
          id: otherCounter--,
          reservationId: this.reservationId,
          timestamp: DateTime.local().toJSON(),
          color: "gray",
          raw: "",
          events: [
            {
              id: 0,
              timestamp: DateTime.local().toJSON(),
              name: message,
            },
          ],
        } as RawScanDescriptor;

        this.debugData.push(descriptor);
      }
    });

    connection.on("scanned", (message: OcrData) => {
      if (!this.internalOpen) {
        return;
      }

      const descriptor = {
        id: this.debugIdCounter++,
        reservationId: this.reservationId,
        timestamp: DateTime.local().toJSON(),
        color: "success",
        raw: message,
        events: [],
      } as RawScanDescriptor;

      this.debugData.push(descriptor);

      let eventIdCounter = 0;
      function addDescriptorEvent(name: string) {
        descriptor.events.push({
          id: eventIdCounter++,
          timestamp: DateTime.local().toJSON(),
          name,
        });
      }

      if (!message?.isValid) {
        this.beginShake();
        this.beginScanfail();

        descriptor.color = "error";
        addDescriptorEvent("INVALID");
      }

      if (this.internalValue) {
        const currentTab = this.internalValue[this.tab];

        let messageDocType = null as number | null;
        messageDocType = getIdentificationDocumentType(
          this.eVisitorIntegrationId,
          message.docType
        );

        if (
          messageDocType ==
            IdentificationDocumentTypesEnum.IdCard_HR_eVisitor ||
          messageDocType ==
            IdentificationDocumentTypesEnum.IdCard_SL_eTurizem ||
          messageDocType == IdentificationDocumentTypesEnum.IdCard_None
        ) {
          addDescriptorEvent("TYPE:IDENTITY CARD");
        } else if (
          messageDocType ==
            IdentificationDocumentTypesEnum.Passport_HR_eVisitor ||
          messageDocType ==
            IdentificationDocumentTypesEnum.Passport_SL_eTurizem ||
          messageDocType == IdentificationDocumentTypesEnum.Passport_None
        ) {
          addDescriptorEvent("TYPE:PASSPORT");
        } else {
          addDescriptorEvent("TYPE:UNKNOWN");
        }

        const issuingState = this._countries?.find(
          (x) =>
            x.isoThreeLetterCode?.toLowerCase() ===
            message.issuingState?.toLowerCase()
        );
        addDescriptorEvent("STATE:" + issuingState?.isoThreeLetterCode);

        const sameCustomerByDocNumber = (x: ReservationCheckInCustomerData) =>
          x.identificationDocumentNumber === message.docNumber &&
          x.identificationDocumentTypeId === messageDocType &&
          x.countryOfResidenceId === issuingState?.id;

        const existing = currentTab.guests.find(sameCustomerByDocNumber);

        if (existing) {
          descriptor.color = "blue";
          addDescriptorEvent(
            "FOUND_EXISTING:" +
              currentTab.displayName() +
              "-" +
              existing.id +
              "-" +
              existing.firstName
          );
          this.assignCustomerData(currentTab, existing, message);
          addDescriptorEvent("FILLED_EXISTING");
          return;
        } else {
          addDescriptorEvent("FOUND_EXISTING:false");
        }

        const emptyCount = currentTab.guests.filter((x) => x.isEmpty).length;
        if (emptyCount === 0) {
          this.addGuest(currentTab);
          addDescriptorEvent("ADD_EMPTY_CARD");
        }

        const empty = currentTab.guests.find((x) => x.isEmpty);
        if (empty) {
          this.assignCustomerData(currentTab, empty, message);
          addDescriptorEvent("FILLED_CURENT_TAB_EMPTY_CARD");
          return;
        }
      }
    });

    this.connection = connection;

    const prom = (this.startedPromise = connection
      .start()
      .then(() => (this.connected = true))
      .catch((err) => {
        console.warn("Failed to connect with hub, retrying...", err);

        this.retryAttempt++;

        // prettier-ignore
        return new Promise((resolve, reject) =>
        setTimeout(() => {
          if (this.retryAttempt <= 4 && prom === this.startedPromise) {
            return this.start().then(resolve).catch(reject);
          } else {
            reject('Failed to connect with hub, retry attempts reached')
          }
        }, this.retryAttempt*this.retryAttempt*2000)
      );
      }));

    connection.onclose(() => (this.connected = false));

    return this.startedPromise;
  }

  assignCustomerData(
    aut: CheckedInCustomersOnAccUnitType,
    target: ReservationCheckInCustomerData,
    values: OcrData
  ) {
    assignToReservationCheckInCustomerData(
      target,
      values,
      this._countries ?? [],
      this.eVisitorIntegrationId
    );
    this.prefilMiscCustomerData(aut, target);

    target.hasScanIssues = !values?.isValid;

    target.isDirty = true;
    target.isEmpty = false;
  }

  prefilMiscCustomerData(
    aut: CheckedInCustomersOnAccUnitType,
    target: ReservationCheckInCustomerData
  ) {
    if (!target.eVisitorCheckInDate || target.eVisitorCheckInDate === "") {
      target.eVisitorCheckInDate = target.checkInDate = DateTime.local()
        .toISODate()
        .substr(0, 10);
    }
    if (!target.eVisitorCheckInTime || target.eVisitorCheckInTime === "") {
      target.eVisitorCheckInTime = DateTime.local().toISOTime().substring(0, 5);
    }

    const accUnitType = this.reservation?.accomodationUnitTypes.find(
      (x) => x.id === aut.reservationAccUnitTypeId
    );

    if (accUnitType) {
      if (
        !target.eVisitorExpectedCheckoutTime ||
        target.eVisitorExpectedCheckoutTime === ""
      ) {
        target.eVisitorExpectedCheckoutTime =
          accUnitType.expectedDepartureTime?.substr(0, 5) ??
          aut.propertyCheckOutTime?.substr(0, 5) ??
          null;
      }
      if (
        !target.eVisitorExpectedCheckoutDate ||
        target.eVisitorExpectedCheckoutDate === ""
      ) {
        target.eVisitorExpectedCheckoutDate = target.checkOutDate =
          accUnitType.departureDate?.substr(0, 10) ?? null;
      }
    }

    if (!target.eVisitorArrivalOrganizationTypeId)
      if (!target.eVisitorFacilityPropertyId) {
        const propId = this.reservation?.accomodationUnitTypes?.length
          ? this.reservation?.accomodationUnitTypes[0].propertyId ?? null
          : null;

        target.eVisitorFacilityPropertyId = propId;
      }

    if (!target.eVisitorFacilityId) {
      const group = this.eVisitorFacilityService?.findGroup(
        target.eVisitorFacilityPropertyId ?? 0
      );

      if (group?.facilities?.length === 1) {
        target.eVisitorFacilityId = group.facilities[0].id;
      } else if (!target.eVisitorFacilityPropertyId) {
        target.eVisitorFacilityPropertyId = accUnitType?.propertyId ?? null;
      }
    }
  }

  onDirty(
    aut: CheckedInCustomersOnAccUnitType,
    guest: ReservationCheckInCustomerData
  ) {
    this.prefilMiscCustomerData(aut, guest);
  }

  debug = false;
  debugIdCounter = 0;
  debugData = [] as RawScanDescriptor[];
}
